import {Stack, Typography} from "@mui/material";
import {isEmpty} from "../../config/commonFunctions";
import {keys} from "../../config/nameSpacesKeys";
import {useState} from "react";

export default function DistributionDisplay(props) {
  // const [mappings, setMappings] = useState(props.mappings);
  const [distributionsList, setDistributionsList] = useState(props.distributionsList);
  const {defaultLanguage, mappings, topLabel} = props;

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }

  if (!distributionsList || distributionsList.length === 0) return null;

  return (
    <div>
      {/* Pivot Language Heading */}
      <Typography variant="h4" gutterBottom noWrap sx={{pt: 1}}>{topLabel}</Typography>
      {distributionsList.getDistributionsList().map((item, index) => {
        return (
          <Stack key={index} sx={{pt: 1}} spacing={1}>
            {!isEmpty(item.byteSize.getCurrentValue()) && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.byteSize, "byteSize")}
                </Typography>
                <Typography variant="body1">{item.byteSize.getValue()}</Typography>
              </div>
            )}
            {/* !isEmpty(item.mediaType.getValue()) &&(<div>
                    <Typography variant="body2" className={"key"}>{getLabel(keys.msmediaType, "distributionMediaType")}</Typography>
                    <Typography variant="body1">{getLabel(item.mediaType.getValue())}</Typography>
                  </div>) */}
            {!isEmpty(getLabel(item.packageFormat.getValue())) && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.packageFormat, "format")}
                </Typography>
                <Typography variant="body1">{getLabel(item.packageFormat.getValue())}</Typography>
              </div>
            )}
            {!isEmpty(item.format.getList()) && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.format, "format")}
                </Typography>
                {item.format.getList().map((item, index) => (
                  <div key={index}>{getLabel(item.getValue())}</div>
                ))}
              </div>
            )}
            <div>
              <Typography variant="body2" className={"key"}>
                {getLabel(keys.size, "size")}
              </Typography>
              {item.size.map((sizeItem, index) => (
                <span key={index}>
                  {" "}
                  <Typography variant="body1">
                    {sizeItem.amount.getCurrentValue()} {getLabel(sizeItem.sizeUnit.getValue())}
                  </Typography>
                </span>
              ))}
            </div>
          </Stack>
        );
      })}


    </div>
  );
}
